let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fuSUS")).then(() => parcelRequire('1G9i6'));